<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-4 border-bottom-1 border-200"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-orange-50 p-3 border-1 border-orange-100 border-round-lg">
            <i class="pi pi-directions text-orange-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div class="flex justify-content-center mb-4">
         <p-selectButton
            [options]="visibleTabs()"
            [ngModel]="activeTab()"
            (ngModelChange)="activeTab.set($event)"
            optionLabel="label"
            optionValue="value"
         ></p-selectButton>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-4 overflow-auto h-80">
      <div class="flex flex-column gap-4">
          <div *ngIf="selectedTargetNodeId() && previewMessage()" class="flex flex-column gap-3">
              <span class="font-semibold text-900 px-1">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.PREVIEW.MESSAGE_LABEL' | translate }}</span>
              <div class="surface-card p-4 border-1 border-round-xl border-200 bg-white shadow-1">
                  <div class="flex align-items-start gap-3">
                      <div class="bg-gray-100 border-round p-2">
                          <i [class]="'pi ' + getNodeIcon(selectedTargetNode()?.type!) + ' text-600'"></i>
                      </div>
                      <div class="flex flex-column gap-2 flex-grow-1">
                          <span class="font-bold text-900">{{ targetNodeCopies()[selectedTargetNodeId()!]?.name }}</span>
                          <div class="p-3 bg-bluegray-50 border-round-lg text-700 line-height-3 text-sm italic">
                              "{{ previewMessage() }}"
                          </div>
                      </div>
                  </div>
              </div>
          </div>

         <div *ngIf="selectedStatuses().length > 0" class="flex flex-column gap-3">
            <div class="flex flex-wrap gap-2">
               <div *ngFor="let s of selectedStatuses()" class="flex align-items-center gap-2 px-3 py-2 border-round-2xl bg-white border-1 border-200 shadow-sm">
                  <i [class]="statusOptions[0].icon + ' text-blue-500'" *ngIf="s === 'received'"></i>
                  <i [class]="statusOptions[1].icon + ' text-green-500'" *ngIf="s === 'read'"></i>
                  <i [class]="statusOptions[2].icon + ' text-red-500'" *ngIf="s === 'error'"></i>
                  <span class="text-sm font-medium text-700">
                     {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUS_' + s.toUpperCase() | translate }}
                  </span>
               </div>
            </div>
         </div>

          <p-messages severity="info" [closable]="false">
              <ng-template pTemplate>
                  <div class="flex flex-row gap-3 py-2 px-1">
                      <i class="pi pi-directions text-2xl"></i>
                      <div class="flex flex-column gap-1">
                     <span class="font-bold">
                        {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.PREVIEW.TITLE' | translate }}
                     </span>
                          <span class="line-height-3" [innerHTML]="previewSummary() || ( 'DATA.MODULES.INSPECTORS.CONDITIONAL.DESCRIPTION' | translate )">
                     </span>
                      </div>
                  </div>
              </ng-template>
          </p-messages>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-4 overflow-auto h-80">
      <div class="flex flex-column gap-5">

         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <div class="flex align-items-center gap-2">
                  <span class="font-semibold text-900">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.TARGET_NODE_LABEL' | translate }}</span>
                  <i
                     class="pi pi-question-circle text-500 cursor-help"
                     [pTooltip]="'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.TARGET_NODE_TOOLTIP' | translate"
                     tooltipPosition="top"
                  ></i>
               </div>
               <span class="text-sm text-500">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.TARGET_NODE_HELP' | translate }}</span>
               <div *ngIf="nodeGoalWarning()" class="mt-2">
                  <span class="text-xs text-orange-600 font-medium italic">
                     <i class="pi pi-exclamation-triangle mr-1"></i>
                     {{ nodeGoalWarning() }}
                  </span>
               </div>
            </div>

            <div class="grid mt-1" [ngClass]="{ 'opacity-60 pointer-events-none': isNodeGoalDisabled() }">
               <div *ngFor="let option of targetNodeOptions()" class="col-12">
                  <div
                     class="cursor-pointer border-1 border-round-xl flex flex-column transition-all transition-duration-200 overflow-hidden"
                     [ngClass]="selectedTargetNodeId() === option.id ? 'bg-blue-50 border-orange-500 shadow-1' : 'bg-white border-200 hover:border-blue-300'"
                     (click)="onTargetNodeSelect(option.id)"
                  >
                     <div class="p-3 flex align-items-center gap-3">
                        <div
                           class="w-3rem h-3rem border-round flex align-items-center justify-content-center flex-shrink-0"
                           [ngClass]="selectedTargetNodeId() === option.id ? 'bg-blue-500 text-white' : 'bg-gray-100 text-600'"
                        >
                           <i [class]="'pi ' + getNodeIcon(option.type) + ' text-xl'"></i>
                        </div>
                        <div class="flex flex-column overflow-hidden flex-grow-1">
                           <div class="flex justify-content-between align-items-center w-full">
                              <span class="font-bold text-sm text-900 truncate">
                                 {{ targetNodeCopies()[option.id]?.name || (option.type === NodeType.SendSMS ? 'SMS' : 'Email') }}
                              </span>
                              <div class="flex align-items-center gap-2">
                                 <button
                                    *ngIf="getNodeMessage(option.id)"
                                    class="p-button-text p-button-rounded p-button-sm p-0 w-2rem h-2rem flex align-items-center justify-content-center border-none bg-transparent hover:bg-black-alpha-10 cursor-pointer"
                                    (click)="toggleExpandNode(option.id, $event)"
                                    [title]="(expandedNodeId() === option.id ? 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.HIDE_MESSAGE' : 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.VIEW_MESSAGE') | translate"
                                 >
                                    <i [class]="'text-500 pi ' + (expandedNodeId() === option.id ? 'pi-eye-slash' : 'pi-eye')"></i>
                                 </button>
                                 <i *ngIf="selectedTargetNodeId() === option.id" class="pi pi-check-circle text-blue-500 font-bold"></i>
                              </div>
                           </div>
                           <span class="text-xs text-500 truncate" *ngIf="targetNodeCopies()[option.id]?.alias">
                              {{ targetNodeCopies()[option.id]?.alias }}
                           </span>
                           <span class="text-xs text-400 truncate">{{ option.id }}</span>
                        </div>
                     </div>

                     <div
                        *ngIf="expandedNodeId() === option.id"
                        class="px-3 pb-3 pt-0 animate-fadein"
                     >
                        <div class="p-3 bg-white-alpha-60 border-round-lg border-1 border-blue-100 text-xs text-700 line-height-3 italic">
                           "{{ getNodeMessage(option.id) }}"
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUSES_LABEL' | translate }}</span>
               <span class="text-sm text-500">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUSES_HELP' | translate }}</span>
            </div>

            <div class="flex flex-column gap-2 mt-1">
               <div *ngFor="let status of statusOptions" class="w-full">
                  <div
                     class="cursor-pointer p-3 border-1 border-round-xl flex align-items-center justify-content-between gap-3 transition-all transition-duration-200"
                     [ngClass]="selectedStatuses().includes(status.value) ? status.bgColor + ' ' + status.borderColor + ' border-blue-500 shadow-1' : 'bg-white border-200 hover:border-blue-300'"
                     (click)="onStatusToggle(status.value)"
                  >
                     <div class="flex align-items-center gap-3">
                        <div
                           class="w-2rem h-2rem border-round flex align-items-center justify-content-center"
                           [ngClass]="selectedStatuses().includes(status.value) ? status.bgColor : 'bg-gray-100'"
                        >
                           <i [class]="status.icon + ' text-lg ' + (selectedStatuses().includes(status.value) ? status.color : 'text-400')"></i>
                        </div>
                        <div class="flex flex-column">
                           <span class="text-sm font-semibold" [ngClass]="selectedStatuses().includes(status.value) ? 'text-900' : 'text-500'">
                              {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUS_' + status.label.toUpperCase() | translate }}
                           </span>
                           <span class="text-xs text-500">
                              {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUS_' + status.label.toUpperCase() + '_DESC' | translate }}
                           </span>
                        </div>
                     </div>
                     <i *ngIf="selectedStatuses().includes(status.value)" class="pi pi-check-circle text-blue-500 font-bold"></i>
                  </div>
               </div>
            </div>
         </div>

         <p-divider></p-divider>

         <p-messages *ngIf="errors().length > 0" severity="error">
            <ng-template pTemplate="content">
               <div class="flex flex-column gap-1">
                  <div *ngFor="let error of errors()">
                     {{ getErrorMessage(error) }}
                  </div>
               </div>
            </ng-template>
         </p-messages>

      </div>
   </div>
</div>
